import { SpaceSettingsRoute } from './space-settings.route';
import { MobileSettingsNavigation } from '../../../features/settings/components/mobile-settings-navigation';
import { useResponsive } from '../../../hooks/useResponsive';

export const SettingsRoute = () => {
  const { isMobile } = useResponsive();
  return isMobile ? <MobileSettingsNavigation /> : <SpaceSettingsRoute />;
};
